import { type FunctionalComponent, h } from '@stencil/core';
import { DashboardGenericTile } from '../dashboard-generic-tile/dashboard-generic-tile';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';
import type {SearchApiDocument} from '../../../../../../api/model/response/documents/SearchResult';
import type {SearchProduct} from '../../../../../../api/model/response/documents/public/Product';
import {DashboardTileSkeleton} from '../dashbord-documents/dashboard-tile-skeleton';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

interface IDashboardCompanyTileProp extends Pick<IDashboardDesktopView, 'labelProvider' | 'strategies' | 'query' | 'rtl' | 'country' | 'language' | 'lazyLoadImages' | 'sectionsData'> {
  doc: SearchApiDocument[] | SearchProduct[];
  title: string;
  customValueClass?: string;
  targetTab: string;
  tabCount: number;
  section: string;
  privateCard?: boolean;
  showPlaceholder?: boolean;
  limitResults?:boolean;
  limitResultsNumber?: number
  sectionIsLoading?: boolean;
  useSkeleton?: boolean;
  span?: number;
}
export const DashboardCompanyTile: FunctionalComponent<IDashboardCompanyTileProp

> = (props) => {
    const {
      labelProvider,
      doc,
      title,
      customValueClass,
      targetTab,
      tabCount,
      strategies,
      section,
      country,
      language,
      lazyLoadImages,
      query,
      limitResultsNumber,
      sectionIsLoading,
      useSkeleton

    } = props;

    if (sectionIsLoading && useSkeleton) {
      return <DashboardTileSkeleton picturePlaceholder={true} />;
    }

    return (
      doc && doc.length > 0 && (
        <DashboardGenericTile
          labelProvider={(e, f) => labelProvider(e, f)}
          title={title}
          customValueClass={customValueClass}
          targetTab={targetTab}
          tabCount={tabCount}
          itemCount={limitResultsNumber ? limitResultsNumber : doc.length}
          term={query}
        >
          <div class={`company__container${doc[0]?.source == 'VIDEO' ? '-video' : ''}`}>
            {doc.map((el, index) => {
                if (limitResultsNumber && index >= limitResultsNumber) return null;
                if (el.source == 'VIDEO' && el.f1Symbol !== 'Company') {
                  if (!el.video || Object.keys(el.video).length === 0) return null;
                  const videoUrl = el.video?.length > 0 ? el.video[0]?.url : el.video?.url;
                  const videoId = new URL(videoUrl)?.pathname.split('/').pop();
                  el.thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
                  el.url = el.video?.length > 0 ? el.video[0]?.url : el.video?.url;
                  return (
                    <div class="video-item">
                      <dashboard-video-item
                        index={index}
                        doc={el}
                        strategies={strategies}
                        section={section}
                        country={country}
                        language={language}
                        labelProvider={labelProvider as labelProviderInterface}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div class="company-item">
                      <dashboard-company-item
                        index={index}
                        doc={el}
                        strategies={strategies}
                        section={section}
                        lazy-Load-images={lazyLoadImages}
                      />
                    </div>
                  );
                }
            })}
          </div>
        </DashboardGenericTile>
      )
    );
};
